import { useEffect, useRef, useState } from 'react';

type TypewriterOnceProps = {
	text: string;
	speed?: number;
	onDone?: () => void;
	className?: string;
};

export const TypewriterOnce = ({
	text,
	speed = 25,
	onDone,
	className,
}: TypewriterOnceProps) => {
	const [displayed, setDisplayed] = useState('');
	const idx = useRef(0);
	const done = useRef(false);

	useEffect(() => {
		// Respect prefers-reduced-motion
		if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
			setDisplayed(text);
			if (!done.current) {
				done.current = true;
				onDone?.();
			}
			return;
		}

		idx.current = 0;
		setDisplayed('');
		done.current = false;

		const iv = setInterval(() => {
			idx.current += 1;
			setDisplayed(text.slice(0, idx.current));
			if (idx.current >= text.length) {
				clearInterval(iv);
				if (!done.current) {
					done.current = true;
					onDone?.();
				}
			}
		}, speed);

		return () => clearInterval(iv);
	}, [text, speed, onDone]);

	return <span className={className}>{displayed}</span>;
};
